import { Component } from "react";
import Select from "react-select";
import ErrorAlert from "../constantPages/Alerts/ErrorAlert";
import makeAnimated from "react-select/animated";
import Societe from "../../services/Societe";
// this class is used to choose which supplier(fournisseur) will add the Bon de commande
//the respose will be in the class AddBCAchat

class AddBillListSociete extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_message: "",
      idSociete: "",
      societes: [],
      options: [],
    };
  }
  componentDidMount() {
    this.forceUpdate();

    Societe.getSocietesClients(
      this.props.typeSociete,
      this.props.typeClient,
      1,
      0
    )
      .then((response) => {
        if (response.data["Societe"] === "erreur") {
          this.setState({ alert_message: "error" });
        } else {
          this.setState({ societes: response.data["Societe"] });
          this.setState({ alert_message: "success" });
          this.remplissageOptions();
        }
      })
      .catch((error) => {
        this.setState({ alert_message: "error" });
      });
  }
  remplissageOptions() {
    this.state.societes.map((typeBill) =>
      this.setState({
        options: [
          ...this.state.options,
          { value: typeBill.id, label: typeBill.title },
        ],
      })
    );
  }
  handleChange = (selectedOption) => {
    this.setState({ selectedOption }, () =>
      console.log(`Option selected:`, this.state.selectedOption)
    );
    this.setState({ idSociete: selectedOption.value });
    console.log("idSociete", this.state.idSociete);
  };

  saveIdSociete = (e) => {
    console.log(this.state.idSociete);

    localStorage.setItem("idSociete", this.state.idSociete);

    if (this.state.idSociete === "") {
      this.setState({ alert_message: "error choice" });
    } else {
      localStorage.setItem("idSociete", this.state.idSociete);
      console.log("idSociete", localStorage.getItem("idSociete"));
      this.props.history.push("/BCAndBillForAchat");
    }

    e.preventDefault();
  };

  render() {
    const animatedComponents = makeAnimated();

    if (this.props.typeClient === "CLIENT") {
      if (this.state.alert_message === "error") {
        return (
          <div className="content-wrapper">
            <section class="content">
              <div class="row">
                <div class="col-md-12">
                  <ErrorAlert message="Désolé aucun Société cliente à afficher, Vous devez ajouter une société svp" />
                </div>
              </div>
            </section>
          </div>
        );
      } else if (this.state.alert_message === "error choice") {
        return (
          <div className="content-wrapper">
            <section class="content">
              <div class="row">
                <div class="col-md-12">
                  <ErrorAlert message="Vous devez choisir un des clients de la liste" />
                </div>
              </div>

              <div class="card ">
                <div class="card-header">
                  <h3 class="card-title">Liste des clients</h3>
                </div>
                <form
                  className="form-horizontal"
                  onSubmit={this.saveIdSociete}
                ></form>
                {/* /.box-header */}
                <div className="card-body">
                  <div class="form-group">
                    <Select
                      value={this.state.selectedOption}
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      options={this.state.options}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="box-footer">
                  {/* <Link to="/addFraisInscrit" > */}
                  <button
                    type="submit"
                    onClick={this.saveIdSociete}
                    className="btn btn-info "
                  >
                    Valider
                  </button>
                  {/* </Link> */}
                </div>
              </div>
            </section>
          </div>
        );
      } else {
        return (
          <div className="content-wrapper">
            <section class="content">
              <br />
              <div class="row">
                <div class="col-md-12">
                  <div class="card ">
                    <div class="card-header">
                      <h3 class="card-title">Liste des clients</h3>
                    </div>
                    <form
                      className="form-horizontal"
                      onSubmit={this.saveIdTypeBill}
                    ></form>
                    {/* /.box-header */}
                    <div className="card-body">
                      <div class="form-group">
                        <Select
                          value={this.state.selectedOption}
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          options={this.state.options}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                    <div className="card-footer">
                      <button
                        type="submit"
                        onClick={this.saveIdSociete}
                        className="btn btn-info float-right"
                      >
                        Valider
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        );
      }
    } else {
      if (this.state.alert_message === "error") {
        return (
          <div className="content-wrapper">
            <section class="content">
              <div class="row">
                <div class="col-md-12">
                  <ErrorAlert message="Désolé aucun Société Fournisseurs à afficher, Vous devez ajouter une société svp" />
                </div>
              </div>
            </section>
          </div>
        );
      } else if (this.state.alert_message === "error choice") {
        return (
          <div className="content-wrapper">
            <section class="content">
              <div class="row">
                <div class="col-md-12">
                  <ErrorAlert message="Vous devez choisir un des fournisseurs de la liste" />
                </div>
              </div>

              <div class="card ">
                <div class="card-header">
                  <h3 class="card-title">Liste des Fournisseurs</h3>
                </div>
                <form
                  className="form-horizontal"
                  onSubmit={this.saveIdSociete}
                ></form>

                <div className="card-body">
                  <div class="form-group">
                    <Select
                      value={this.state.selectedOption}
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      options={this.state.options}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>

                <div className="card-footer">
                  <button
                    type="submit"
                    onClick={this.saveIdSociete}
                    className="btn btn-info float-right"
                  >
                    Valider
                  </button>
                  {/* </Link> */}
                </div>
              </div>
            </section>
          </div>
        );
      } else {
        return (
          <div className="content-wrapper">
            <section class="content">
              <div class="row">
                <div class="col-md-12">
                  <br />

                  <div class="card ">
                    <div class="card-header">
                      <h3 class="card-title">Liste des Fournisseurs</h3>
                    </div>
                    <form
                      className="form-horizontal"
                      onSubmit={this.saveIdSociete}
                    ></form>

                    <div className="card-body">
                      <div class="form-group">
                        <Select
                          value={this.state.selectedOption}
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          options={this.state.options}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>

                    <div className="card-footer">
                      <button
                        type="submit"
                        onClick={this.saveIdSociete}
                        className="btn btn-info float-right"
                      >
                        Valider
                      </button>
                      {/* </Link> */}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        );
      }
    }
  }
}
export default AddBillListSociete;
